import { Alert, Snackbar } from '@mui/material';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './app/store';
import { clear } from './features/snackbar/snackbarSlice';
export const Snaxbar = () => {
  const message = useSelector((state: RootState) => state.snackbar.message)
  const severity = useSelector((state: RootState) => state.snackbar.severity)
  const dispatch = useDispatch()
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      autoHideDuration={6000}
      message={message}
      onClose={() => dispatch(clear())}
      open={!!message}
    >
      <Alert severity={severity}>{message}</Alert>
    </Snackbar>
  )
}